//#region  Imports

import { Injectable } from '@angular/core';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class LocalStorage {

  //#region Public Methods

  public setItem<T>(key: string, item: T): void {
    localStorage.setItem(key, JSON.stringify(item));
  }

  public getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);

    if (!item)
      return null;

    try {
      return JSON.parse(item) as T;
    } catch {
      return null;
    }
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }

  //#endregion

}
